import './App.css';
import { Route, Routes } from 'react-router-dom';
import Chatting from './page/Chatting';
import Question from './page/Question';
import Login from './page/Login';

function App() {

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/question" element={<Question />} />
      <Route path="/chatting" element={<Chatting />} />
  </Routes>
  );
}

export default App;